import script from "./SugaRemote.vue?vue&type=script&setup=true&lang=ts"
export * from "./SugaRemote.vue?vue&type=script&setup=true&lang=ts"

import "./SugaRemote.vue?vue&type=style&index=0&id=6ae134b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ae134b0"]])

export default __exports__